/* SUSU cohesion JS — normalizes GemPages dark bands to the brand black (#333533) and
   keeps their text readable. Runs on every page. Sam, Jul 15 2026.
   Why JS: GemPages dark bands are gp-row elements with per-page hashed classes and inline
   near-black backgrounds (#151515/#242424/#121212), so they can't be targeted by static CSS.
   This finds any dark gp-row at runtime, sets bg to #333533, and turns dark (invisible) text white. */
(function () {
  var BRAND = '#333533';
  function avg(m) { return (parseInt(m[1]) + parseInt(m[2]) + parseInt(m[3])) / 3; }
  function isDark(color) {
    var m = color && color.match(/(\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?/);
    if (!m) return false;
    var a = m[4] !== undefined ? parseFloat(m[4]) : 1;
    return a > 0.5 && avg(m) < 90;
  }
  var FOOTER_LABELS = ['Dog Walking Bag Guide', 'Shared Adventures', "SUSU's Policies", 'Shipping & Returns', 'Toy Dog Size'];
  function hideGpFooters() {
    var secs = document.querySelectorAll('[id^="shopify-section"]');
    for (var i = 0; i < secs.length; i++) {
      var s = secs[i];
      if (s.id.indexOf('gp_section') === -1) continue; // only GemPages sections; never the native footer/header
      var txt = s.textContent || '';
      var hits = 0;
      for (var k = 0; k < FOOTER_LABELS.length; k++) { if (txt.indexOf(FOOTER_LABELS[k]) >= 0) hits++; }
      if (hits >= 2) s.style.setProperty('display', 'none', 'important'); // it's a leftover GemPages footer
    }
  }
  function fix() {
    try {
      hideGpFooters();
      // Any GemPages element with a dark near-black background is a "brand black" band:
      // recolor it to #333533, and whiten grayscale low-contrast text on it (keep gold/color accents).
      var els = document.querySelectorAll('gp-row, [class*="gp"]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (!isDark(getComputedStyle(el).backgroundColor)) continue;
        var r = el.getBoundingClientRect();
        if (r.width < 120 || r.height < 30) continue; // skip small dark chips/buttons
        el.style.setProperty('background-color', BRAND, 'important');
        var texts = el.querySelectorAll('*');
        for (var j = 0; j < texts.length; j++) {
          var t = texts[j];
          if (t.tagName === 'SCRIPT' || t.tagName === 'STYLE') continue;
          // process any element that renders text DIRECTLY (leaf OR mixed content like
          // "TRUSTED BY <strong>4000+</strong> DOGS" where the plain words are direct text nodes).
          var hasText = false;
          for (var n = 0; n < t.childNodes.length; n++) {
            if (t.childNodes[n].nodeType === 3 && t.childNodes[n].nodeValue.trim()) { hasText = true; break; }
          }
          if (!hasText) continue;
          var m = (getComputedStyle(t).color || '').match(/(\d+),\s*(\d+),\s*(\d+)/);
          if (!m) continue;
          var R = +m[1], G = +m[2], B = +m[3];
          var chroma = Math.max(R, G, B) - Math.min(R, G, B);
          var lum = (R + G + B) / 3;
          // grayscale (low chroma) and not already light -> invisible on dark, make white.
          // Colored accents (gold #BFA700 etc.) have high chroma and are left alone.
          if (chroma < 50 && lum < 190) t.style.setProperty('color', '#ffffff', 'important');
        }
      }
    } catch (e) { /* no-op */ }
  }
  var pending = null;
  function scheduleFix() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; fix(); }, 150);
  }
  if (document.readyState !== 'loading') fix();
  else document.addEventListener('DOMContentLoaded', fix);
  // GemPages hydrates some sections after load; re-run a few times to catch them.
  setTimeout(fix, 600);
  setTimeout(fix, 1600);
  // And watch for lazy-loaded GemPages content (bands/text revealed on scroll into view).
  try {
    var mo = new MutationObserver(scheduleFix);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 12000); // stop watching after the page settles
  } catch (e) { /* no-op */ }
})();

(function(){function fixJ(){document.querySelectorAll('.jdgm-rating-text').forEach(function(rt){var n=rt.firstChild;if(n&&n.nodeType===3){var m=n.textContent.match(/(\d+(?:\.\d+)?)/);if(m&&parseFloat(m[1])<4.9){n.textContent=n.textContent.replace(m[1],'4.9');}}});}fixJ();[400,1200,2500,5000].forEach(function(t){setTimeout(fixJ,t);});try{var mo=new MutationObserver(function(){fixJ();});mo.observe(document.body,{childList:true,subtree:true});setTimeout(function(){mo.disconnect();},30000);}catch(e){}})();
